import { IUserInfo } from '../../components/login/types';
import { ReduxAction } from './reduxAction';

export const updateCurrentLogged = 'update_logged_user';
export const UpdateCurrentLogged = (user: IUserInfo): ReduxAction<IUserInfo> => ({
    type: updateCurrentLogged,
    payload: user,
});
